import { html, render, useEffect, useState } from 'https://esm.sh/htm/preact/standalone';

function ArticleBadge() {

    return html`
    <div class="card__content">
        <div class="card__badge top left">
            <span class="badge color-scheme-1">BLOG</span>
        </div>
    </div>
    `
}

function ArticleImage({ article }) {
    const { image } = article;

    if(!image) return;

    return html`
    <div class="card__inner ratio"  style="--ratio-percent: 100%;" >
        <div class="article-card__image-wrapper card__media">
            <div class="article-card__image media media--hover-effect" >
            <img
                src="${image?.url}"  
                alt="${image?.altText}" 
                width="auto" 
                height="auto" 
            />
            </div>
        </div> 
        <${ArticleBadge} />
    </div>
    `
}

function ArticleContent({ article }) {

    const { title, content, onlineStoreUrl, publishedAt } = article;

    return html`
    <div class="card__content">
        <div class="card__information">  
            <div class="card__information-inner-wrap">

            
                <div class="article-card__info caption-with-letter-spacing h5">
                    <span class="article-card__info-tag-here">
                        How to
                    </span> 
                    <span class="circle-divider">
                        ${publishedAt.replaceAll('-', '/').split('T')[0]}
                    </span>
                </div>  
                <h3 class="card__heading common_small_title">
                    <a href="${onlineStoreUrl}" class="full-unstyled-link">
                       ${title}
                    </a>
                </h3>
                <div class="article-card_content common_info">
                  <p>
                  ${content}
                  </p>
                </div>
            </div>
            <a href="" class="article-card__read-more--btn common_link">Take Quiz</a>
        </div>
    </div>
    `
}

function ArticleCard({ article }) {

    const { tags } = article;

    if(!tags?.some((tag) => tag.includes('Quizzes'))) return;
    document.querySelector('#template-search-quiz_heading').style.display = "block";
    return html`
    <li class="swiper-slide">
        <div class="article-card-wrapper card-wrapper underline-links-hover">
            <div class="card article-card card--card card--media color-scheme-1 gradient" style="--ratio-percent: 100%;" >
                <${ArticleImage} article="${article}"/>
                <${ArticleContent} article="${article}" />
            </div>
        </div>
    </li>
    `
}

async function searchArticles(queryText) {
    const query = `
      query SearchArticles($query: String!) {
        search(query: $query, types: [ARTICLE], first: ${50}) {
            edges {
                cursor
                node {
                    ... on Article {
                        id
                        image {
                            altText
                            url
                        }
                        title
                        content
                        publishedAt
                        onlineStoreUrl 
                        tags
                    }
                }
            }
        }
      }
    `;

    const SHOPIFY_DOMAIN = "laurageller.myshopify.com";
    const ACCESS_TOKEN = "fbbb75ad45c452ff6f0107d78c5a795d";

    const response = await fetch(`https://${SHOPIFY_DOMAIN}/api/2025-04/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': ACCESS_TOKEN
      },
      body: JSON.stringify({
        query,
        variables: { query: queryText }
      })
    });

    const { data } = await response.json();

    return data.search.edges;
}

function SearchArticles() {
    const searchParams = new URLSearchParams(location.search);
    const queryValue = searchParams.get('q');

    const [searchResult, setSearchResult] = useState([]);

    const getAticles = async (value) => {
        const data = await searchArticles(value);

        setSearchResult([...data.map(item => {
            return { ...item.node };
        })]);
    }

    useEffect(() => {
        if(queryValue) {
            getAticles(queryValue);
        }
    }, []);

    if(searchResult.length) {
        document.querySelector('.template-search-quiz').classList.remove('hidden');
    } else {
        document.querySelector('.template-search-quiz').classList.add('hidden');
    }

    return html`
    <ul class="swiper-wrapper grid--2-col-tablet-down grid--4-col-desktop" role="list" >
        ${
            searchResult.map(item => {
                return html`<${ArticleCard} article="${item}"/>`
            })
        }
    </ul>
    `
}
const articleSearch = html`<${SearchArticles}/>`;

// (async () => {

//     await render(articleSearch, document.getElementById('article-search-result'));

//     let swiperInstance = null;
 
//     function initSwiper() {
//       if (swiperInstance) {
//         swiperInstance.destroy(true, true);
//       } 

//       swiperInstance = new Swiper('.js-search-item-swiper', {
//         slidesPerView: 1.2,
//         spaceBetween: 12,
//         watchSlidesProgress: true,
//         draggable: true,
//         autoHeight: false,
//         watchOverflow: true,
//         threshold: 10,
//         mousewheel: {
//           forceToAxis: true
//         },
//         breakpoints: {
//           0: { slidesPerView: 1.2, spaceBetween: 12 },
//           640: { slidesPerView: 2, spaceBetween: 14 },
//           768: { slidesPerView: 2.5, spaceBetween: 16 },
//           990: { slidesPerView: 3, spaceBetween: 16 },
//           1279: { slidesPerView: 4, spaceBetween: 16 }
//         }
//       });
//     }

//     const wrapper = document.querySelector('#article-search-result .swiper-wrapper');

//     if (wrapper) {
//       const observer = new MutationObserver(function () {
//         const slides = wrapper.querySelectorAll('.swiper-slide');
//         if (slides.length > 0) {
//           initSwiper();
//         }
//       });

//       observer.observe(wrapper, {
//         childList: true,
//         subtree: false
//       });

//       if (wrapper.querySelector('.swiper-slide')) {
//         initSwiper();
//       }
//     }
// })()